import { jsPDF } from "jspdf";
import banner1 from "../../../Assets/ptags/banner.jpg";

export const generatePDF2 = (pages = 1, bannerImg) => {
  const width = 1632;
  const height = 1056;
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "pt",
    format: [width, height],
  });

  const columns = 4;
  const rows = 2;
  const sectionWidth = width / columns;
  const sectionHeight = height / rows;

  const bannerImgWidth = sectionWidth - 5;
  const bannerImgHeight = 70;

  for (let p = 0; p < pages; p++) {
    if (p > 0) doc.addPage();

    for (let i = 0; i < columns * rows; i++) {
      const col = i % columns;
      const row = Math.floor(i / columns);

      const xPos = col * sectionWidth + 2.5;
      const yPos = row * sectionHeight + 2.5;

      // Draw banner
      doc.addImage(bannerImg, "JPEG", xPos, yPos, bannerImgWidth, bannerImgHeight);

      // Draw frame under banner
      const frameX = xPos + 2.5;
      const frameY = yPos + bannerImgHeight + 4.8;
      const frameW = sectionWidth - 10;
      const frameH = sectionHeight - (bannerImgHeight + 12);

      doc.setLineWidth(2);
      doc.setDrawColor(71, 74, 119);
      doc.rect(frameX, frameY, frameW, frameH, 'S');
    }

    // Optional: draw grid lines for visual separation
    doc.setLineDashPattern([10, 5], 0);
    doc.setDrawColor(0);
    doc.setLineWidth(1);

    // Horizontal lines
    doc.line(0, height / 2, width, height / 2);

    // Vertical lines
    const colWidth = width / columns;
    for (let c = 1; c < columns; c++) {
      doc.line(colWidth * c, 0, colWidth * c, height);
    }
  }

  // Save the PDF
   doc.save("landscape-4x4.pdf");
};
